<template>
  <Dialog :commonDialog="mDialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <v-layout>
        <v-flex> Manage {{ title }} </v-flex>
        <v-flex class="text-right">
          <v-btn
            depressed
            small
            class="mx-4 white--text"
            color="cyan"
            v-on:click="createSetting"
          >
            <span class="font-size-16 font-weight-600">Add {{ title }}</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow"
        style="max-height: 90vh; position: relative"
      >
        <v-form
          ref="settingsForm"
          v-model.trim="formValid"
          lazy-validation
          v-on:submit.stop.prevent="updateSettings"
        >
          <v-container class="py-0">
            <v-row class="py-0">
              <v-col md="12" class="py-0">
                <table class="width-100">
                  <tbody>
                    <tr v-for="(type, index) in settingsList" :key="index">
                      <td>
                        <v-text-field
                          v-model.trim="type.value"
                          dense
                          filled
                          :placeholder="title"
                          solo
                          flat
                          class="px-4 py-2"
                          hide-details
                          :disabled="pageLoading"
                          :loading="pageLoading"
                          :rules="[validateRules.required(type.value, title)]"
                          color="cyan"
                        ></v-text-field>
                      </td>
                      <td width="50" v-if="settingsList.length > 1">
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-on:click="deleteSetting(index)"
                              color="deep-orange"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-delete</v-icon
                            >
                          </template>
                          <span>Click here to delete</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </perfect-scrollbar>
    </template>
    <template v-slot:action>
      <v-btn
        depressed
        :disabled="pageLoading || !formValid"
        :loading="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button white--text"
        color="cyan"
        v-on:click="updateSettings"
      >
        Save
      </v-btn>
      <v-btn
        depressed
        :disabled="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close-dialog', true)"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CommonMixin from "@/core/plugins/common-mixin";

export default {
  mixins: [ValidationMixin, CommonMixin],
  props: {
    mDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },
    product_type: {
      type: String,
      required: true,
    },
    settings: {
      type: Array,
      default: () => {
        return new Array();
      },
    },
    title: {
      type: String,
      required: true,
    },

    value: {
      type: String,
      required: true,
    },
  },
  watch: {
    settings: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param && param.length > 0) {
          this.settingsList = param.map((item) => ({
            field: this.value,
            value: item.value,
          }));
        } else {
          this.settingsList = [
            {
              field: this.value,
              value: null,
            },
          ];
        }
      },
    },
  },
  data: () => {
    return {
      formValid: true,
      pageLoading: false,
      settingsList: [
        {
          field: "",
          value: null,
        },
      ],
    };
  },
  methods: {
    updateSettings() {
      const _this = this;
      const formErrors = _this.validateForm(_this.$refs.settingsForm);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
          _this.pageLoading = false;
        }
        return false;
      }
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "setting/unit-settings/" + _this.type,
          data: {
            field: _this.value,
            product_type: _this.product_type,
            settings: _this.settingsList.map((item) => ({
              value: item.value,
            })),
          },
        })
        .then(() => {
          _this.$emit("close-dialog", true);
          _this.$emit("get-settings", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    createSetting() {
      this.settingsList.push({
        value: null,
        field: this.value,
      });
    },
    deleteSetting(index) {
      if (this.settingsList.length > 1) {
        this.settingsList.splice(index, 1);
      }
    },
  },
  components: {
    Dialog,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
  mounted() {},
};
</script>
